import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'sa-header-demo',
  templateUrl: './demo.component.html',
})
export class HeaderDemoComponent implements OnInit {

    constructor() { }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/layout/header/demo/demo.component.ts